module.exports = {
  global: {
    empty: '暂无数据',
    dialogTitle: '温馨提示',
    back: '返回'
  },
  nopaid: {
    title: '温馨提示',
    message: '您还有未支付订单',
    cancleBtn: '取消订单',
    goDetail: '前往查看',
    goPay: '前往支付'
  },
  home: {
    checkIn: '入住',
    checkOut: '离店',
    night: '晚',
    cityPickerTitle: '选择城市',
    datePickerTitle: '日期选择',
    loadall: '以上是全部酒店信息',
    searchTip: '搜索酒店',
    searchPlaceholder: '请输入酒店名称',
    listTile: '推荐酒店',
    distance: '距会场',
    price: '市价',
    isEnd: '预订已经结束',
    noStart: '预订暂未开始',
    timeOut: '预订已经截止',
    cityUnknow: '未知',
    area: '城市选择：'
  },
  hotel: {
    navigate: '位置导航',
    contact: '联系酒店',
    distance: '距会场',
    intro: '简介',
    roomType: '房型',
    navigateTips: '为了您有更好的导航体验，请在微信中浏览本页面。',
    confirmText: '知道了',
    roomTypeBtn: '选择房型',
    checkIn: '入住',
    checkOut: '离店',
    night: '晚',
    detail: '详情',
    marketPrice: '市价',
    bookBtnText: '预订',
    loadall: '已经加载全部内容',
    datePickerTitle: '日期选择',
    start: '起'
  },
  book: {
    checkIn: '入住',
    checkOut: '离店',
    total: '共',
    night: '晚',
    bedNum: '床位数量',
    roomNum: '房间数量',
    formTitle: '填写信息',
    saleTitle: '预订政策',
    submitText: '确认订房',
    form: {
      countrycode: '国别区号',
      label: '验证码',
      placeholder: '请输入验证码',
      empty: '请填写验证码',
      err: '验证码格式不正确',
      send: '发送验证码',
      format: 'ss 秒',
      emptyc: '请填写国别区号',
      emptyp: '请填写手机号码',
      success: '发送成功，请注意查看手机短信',
      discern: '内容识别中...'
    },
    validator: {
      phone: '手机号格式有误',
      email: '请输入有效的邮箱地址',
      idnumber: '请输入有效的身份证号码',
      digit: '请输入整数或小数；小数时，小数点后最多保留两位',
      letter: '请不要输入除字母以外的字符',
      require: '该项为必填项'
    },
  },
  notify: {
    uploadImg: '只支持上传.jpg，.jpeg，.png格式的图片!',
    uploadSize5: '文件大小不能超过 5MB!',
    uploadSize15: '文件大小不能超过 15MB!',
    uploadSuc: '文件上传成功！',
    payVoucher: '请上传支付凭证',
    orderTip1: '该订单不支持在小程序内支付',
    orderTip2: '该订单需在小程序内发起支付流程',
    browserTip: '请在微信中打开本页面',
    noFinish: '您有未完成的项目',
    countryCodeTip: '请填写国别区号！',
    phoneTip: '请填写手机号码！',
    phoneErr: '手机号码格式有误！',
    sendSms: '发送成功，请注意查看手机短信',
  },
  result: {
    wait: '等待支付',
    success: '预订成功',
    invalid: '已失效',
    cancel: '已取消',
    orderTitle: '订单信息',
    orderNo: '订单编号',
    checkHotel: '入住酒店',
    checkRoom: '入住房型',
    orderGood: '预订商品',
    price: '商品价格',
    orderNum: '预订数量',
    checkInDate: '入住日期',
    checkOutDate: '离店日期',
    checkDays: '入住晚数',
    amounts: '订单金额',
    guestInfo: '预订人信息',
    payment: '立即支付',
    continue: '继续预订',
  },
  parment: {
    voucher: '点击上传支付凭证',
    submit1: '确认预订',
    cancel: '取消返回',
    submit2: '确认下单',
    wxpay: '微信支付',
    alipay: '支付宝支付',
    paypal: 'Paypal 支付',
    offline: '转账付款'
  }
}